<template>
    <div class="banner flexColumn">
        <top-tab
            :topBarDatas="topBarDatas"
        ></top-tab>
        <div class="contentBox">
            <box-border
                title="工作督办"
            >
                <echart-module
                    :option="workSupervise"
                    ref="workSupervise"
                ></echart-module>
            </box-border>
            <box-border
                title="业主回复意见"
            >
                <echart-module
                    :option="OwnerReply"
                    ref="OwnerReply"
                ></echart-module>
            </box-border>
            <box-border
                title="项目文档跟踪"
                :boxStyle="{
                    'grid-column': '3 / span 2'
                }"
            >
                <echart-module
                    ref="tracking"
                    :option="tracking"
                    style="height: 100%;width: 100%;"
                ></echart-module>
            </box-border>

            <box-border
                title="文档类型跟踪"
                :boxStyle="{
                    'grid-column': '1 / span 2'
                }"
            >
                <Table
                    v-bind="typeTableData"
                    :tableStyle="{
                        height: '100%',
                    }"
                ></Table>
            </box-border>
            <box-border
                title="公司文档跟踪"
                :boxStyle="{
                    'grid-column': '3 / span 2'
                }"
            >
                <Table
                    v-bind="companyTableData"
                    :tableStyle="{
                        height: '100%',
                    }"
                ></Table>
            </box-border>
        </div>
    </div>
</template>
<script>
    export default{
        name: 'Document',
        data(){
            const obj = {
                dataZoom: [
                    {
                        height: this.fontSizeFn(20),
                        moveHandleSize: 0,
                        bottom: 10,
                        textStyle: {
                            color: '#8392A5'
                        },
                        dataBackground: {
                        areaStyle: {
                            color: '#8392A5'
                        },
                        lineStyle: {
                            opacity: 0.8,
                            color: '#8392A5'
                        }
                        },
                        brushSelect: true
                    }, {
                        type: 'inside',
                        filterMode: 'filter'
                    }
                ]
            }
            return {
                //工作督办
                workSupervise: {
                    legend: {
                        show: false
                    },
                    tooltip: {
                        trigger: 'item',
                    }
                },
                //业主回复意见
                OwnerReply: {
                    legend: {
                        show: false
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: function(params){
                            let htmls = `<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:#FFFFFF;"></span>已发送&nbsp;&nbsp;`;
                            htmls += params.data.s2 + '<br/>';
                            htmls += params.marker + params.name + '&nbsp&nbsp' + params.value;
                            return htmls;
                        }
                    }
                },
                //Document by Type
                typeTableData: {},
                //Document by Company
                companyTableData: {},
                //Document Tracking
                tracking: {
                    grid: {
                        top: '15%',
                        bottom: this.fontSizeFn(35),
                        right: '2%'
                    },
                    color: [1, 0, 1, 0],
                    legend: {
                        top: '0%'
                    },
                    ...obj
                },
                topBarDatas: [],
                stype: 'Project',
            }
        },
        mounted() {
            this.topBarDatas = [
                {
                    name: 'Overall',
                    fn: () => {
                        this.stype = 'Project';
                        this.renderFn();
                    }
                },
                {
                    name: 'IU',
                    fn: () => {
                        this.stype = 'IU';
                        this.renderFn();
                    }
                },
                {
                    name: 'OOU',
                    fn: () => {
                        this.stype = 'OOU';
                        this.renderFn();
                    }
                }
            ]
        },
        methods: {
            renderFn(){
                this.getAllPromise([
                    //工作督办
                    async () => {
                        this.getPieVosData(
                            {
                                id: '2c92808382e7577c0182e7d6155e0000',
                                stype: 0
                            },
                            '',
                            this.$refs.workSupervise.myChart,
                            {
                                name: 'workSupervise',
                                clickFn: (params) => {
                                    window.open(`${location.origin}/uganda/doc/WuTaskJoinTrackFp?sysComplete=${params.name}`)
                                }
                            }
                        )
                    },
                    //业主回复意见
                    async () => {
                        this.getPieVosData(
                            {
                                id: '2c92808382e7577c0182e7d659f20001',
                                stype: 0
                            },
                            '',
                            this.$refs.OwnerReply.myChart,
                            {
                                name: 'OwnerReply',
                                otherKeys: ['s2']
                            }
                        )
                    },
                    //Document by Type
                    async () => {
                        const data = await this.getTableData('2c92808f82c8b4510182c93c7d360001', this.stype);
                        this.typeTableData = data;
                    },
                    //Document by Company
                    async () => {
                        const data = await this.getTableData('2c92808f82c8b4510182c93d1ed80002', this.stype);
                        this.companyTableData = data;
                    },
                    //Document Tracking
                    async () => {
                        this.getNewVTos({
                                id: '2c92808f82c8b4510182c93dd93f0003',
                                stype: this.stype
                            },
                            [
                                ['累计发送', '累计接收', '本周发送', '本周接收'],
                                ['line', 'line', 'bar', 'bar'],
                                [1, 1, 0, 0]
                            ],
                            this.$refs.tracking.myChart,
                            {
                                name: 'tracking',
                                yAxisLines: 4,
                                // yMaxArr: [ null, 100 ]
                            }
                        )
                    }
                ]);
            }
        },
    }
</script>
<style lang="less">
    .banner{
        padding-top: 0.12rem;
    }
    .contentBox{
        height: 92%;
        .gridStyle(4, 2, 0.24rem, 0.1rem);
    }
</style>